import { useEffect, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { MailOutlined, UserOutlined, TeamOutlined, UserSwitchOutlined, IdcardOutlined, UnorderedListOutlined, DatabaseFilled, DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { CompanyRole } from '../../Types/CompanyRole';
import { CustomListService } from '../../Services/CustomListService';
import { CustomListType } from '../../Types/CustomListType';

const LeftMenu = (props: any) => {
    const [current, setCurrent] = useState('1');
    const { user } = useAuth();
    const [customLists, setCustomLists] = useState<any[]>([]);
    const GetText = TextService.GetText;
    const navigation = useNavigate();

    useEffect(() => {
        // Fetch custom lists for menu
        CustomListService.GetCustomLists().then(lists => {
            setCustomLists(lists || []);
        });
    }, []);

    // Update selected menu item when props.selected changes
    useEffect(() => {
        setCurrent(props.selected);
    }, [props.selected]);

    type MenuItem = Required<MenuProps>['items'][number];

    const onClick: MenuProps['onClick'] = (e: any) => {
        navigation("/" + getCurrentLanguage() + "/" + e.key);
    };

    function getItem(
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const visibleCustomLists = customLists.filter(list => list.listType !== CustomListType.FamilyMember);

    const customListMenuItems: MenuItem[] = visibleCustomLists.length > 0
        ? [
            getItem(GetText('CustomListSettings_Title'), 'customListsHeader', undefined, undefined, 'group'),
            ...visibleCustomLists.map(list =>
                getItem(list.name, `customList/${list.id}`, <DatabaseOutlined />)
            ),
            getItem(GetText('CustomList_HistoryTitle'), 'customListHistory', <IdcardOutlined />)
        ]
        : [];

    const items: MenuItem[] = user?.role == CompanyRole.GlobalAdmin ? [
        getItem(GetText("Users_UsersTitle"), 'users', <UserOutlined />),
        getItem(GetText("Groups_GroupsTitle"), 'groups', <TeamOutlined />),

        getItem(GetText("Users_UserHistoryTitle"), 'userHistory', <IdcardOutlined />),
        ...customListMenuItems,
    ] : [
        getItem(GetText("Users_UsersTitle"), 'users', <UserOutlined />),
        getItem(GetText("Groups_GroupsTitle"), 'groups', <TeamOutlined />),
        ...customListMenuItems,
    ];

    return <Menu
        theme="light"
        onClick={onClick}
        defaultOpenKeys={['sub1']}
        selectedKeys={[current]}
        mode="inline"
        items={items}
    />
};

export default LeftMenu;